// extracted by mini-css-extract-plugin
module.exports = {"root":"ob_FMZ3ND","logo":"ob_p3VNpm","content":"ob_veBPAD","actions":"ob_mdkpMa","actions__btns":"ob_TpKX3J","debug":"ob_AUaY0G"};